import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"
import { CursorType } from "utils/types"
export type RatingType = {
    key: string;
    uuid: string;
    identity: string;
    score: number;
    item_uuid: string;
    item_owner_identity: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: RatingType) => void;
};

// Domain object Rating
export class Rating implements RatingType {
    key = "";
    uuid = "";
    identity = "";
    score = 0;
    item_uuid = "";
    item_owner_identity = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: RatingType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: RatingType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class RatingStore extends BaseStore<RatingType, Rating> {


    async rateItem(item_uuid: string,
        score: number,
        identity: string,
        item_owner_identity: string) {

            const data = {
                item_uuid: item_uuid,
                score: score,
                identity: identity,
                item_owner_identity: item_owner_identity
            };
            const response = await api_post('/rating/rate', data);
        if(response.ok) {
            const data = await response.json();
            console.log("RatingStore.rateItem", data.rating);
            this.receiveUpdate(data.rating);
            return data.rating;
        }
        return null;
    }
    async fetchRating(uuid: string) {
        // Autogenerated
        const response = await api_get(`/rating?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    async fetchListByIdentityRating(identity_uuid: string, cursor?: CursorType): Promise<RatingType[]>  {
        // Autogenerated
        var url = `/rating/by-identity?identity=${identity_uuid}` +
            (cursor ? `&cursor=${cursor}` : '');
        const response = await api_get(url);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByIdentityRating(identity_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but RatingStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    modelConstructor() {
        return Rating;
    }

}
